import { areaApi } from "@/core/apis";

// getter types
export const AREAS = "areas";

// action types
export const GET_AREAS = "getAreas";

// mutation types
const SET_AREAS = "setAreas";

const state = {
  areas: []
};

const getters = {
  [AREAS](state) {
    return state.areas;
  }
};

const actions = {
  [GET_AREAS](context) {
    return new Promise(resolve => {
      areaApi.getAllAreas().then(response => {
        context.commit(SET_AREAS, response.areas);

        resolve();
      });
    });
  }
};

const mutations = {
  [SET_AREAS](state, areas) {
    state.areas = areas;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
